<template>
  <section class="back-in-stock-drawer-group">
    <slot />
  </section>
</template>

<script>

/**
 * Vue: Back in stock drawer group (back-in-stock-drawer-group)
 * -----------------------------------------------------------------------------
 * Back in stock drawer section group component.
 *
 */

export default {
  name: 'BackInStockDrawerGroup',
}
</script>
